import React from "react";
import { render } from "react-dom";
import PreCallPopup from "venuescanner-js/react/components/CallPopup/PreCallPopup";
import { popup } from "venuescanner-js/vanilla/components/popup";
import inboxService from "venuescanner-js/services/inbox";

const Call = ({
  calleeName,
  myNumber,
  threadId,
  fullscreen,
  dismiss = () => {},
}) => {
  // console.log({ calleeName, myNumber, threadId })
  const container = document.createElement("div");
  render(
    <PreCallPopup
      calleeName={calleeName}
      myNumber={myNumber}
      // onUpdateNumber={updateNumber}
      dismiss={() => {
        popup.close();
        dismiss();
      }}
      requestCall={(statusCb, updatedNumber) => {
        inboxService.init(async () => {
          const call = await inboxService.call.start({
            threadId: threadId,
            number: updatedNumber || myNumber,
          });
          let subscription;
          const subCallback = (data) => {
            statusCb(data);
            if (data.callFinished === true) {
              subscription.unsubscribe();
            }
          };
          subscription = call.observable().subscribe(subCallback);
        });
      }}
    />,
    container
  );
  popup.new(container, { closable: true, fullscreen });
};

export default Call;
